import { FsAdvancedMarker } from '@lib/geo/google/map';
import { t } from '@lib/translation';
import { LprCameraModel } from '@lib/vehicle-intelligence/api';

export class FsLprQueryCameraAdvancedMarker extends FsAdvancedMarker {
  constructor(public camera: any, public animate?: boolean) {
    // Handle both position.coordinates and geometry.coordinates data structures
    const coordinates = camera.position?.coordinates || camera.geometry?.coordinates;
    if (!coordinates || coordinates.length < 2) {
      throw new Error('Camera data missing valid coordinates');
    }

    super(
      {
        position: new google.maps.LatLng(coordinates[1], coordinates[0]),
        title: camera.id,
        content: document.createElement('div'),
        collisionBehavior: google.maps.CollisionBehavior.REQUIRED,
      },
      '.fs__advanced-marker-expand',
    );
    const content: any = this.getMarker().content;
    const imgIcon = this._getCameraIcon(camera).makeIcon;

    if (this.camera.provider?.toString()?.toLowerCase().includes('vigilant')) {
      content.classList.add('fs__lpr-camera-advanced-marker-vigilant');
    }

    if (animate) {
      content.classList.add('fs__lpr-camera-advanced-marker-animate');
    } else {
      content.classList.add('fs__lpr-camera-advanced-marker');
    }
    content.innerHTML = animate
      ? `
    <img class="fs__lpr-camera-icon" src="/assets/fusus-icons/PNG/${imgIcon}.png"/>
    <div class="fs_lpr_camera-details-marker">
      <dt>${t('common.id')}:</dt>
      <dd class="fs-text-wrap">
        ${camera.id}
      </dd>
      <dt>${t('vehicleIntelligence.lastObservedDate')}:</dt>
      <dd class="fs-text-wrap">
        ${this.formatDate(camera.lastEvent).toDateString()}
      </dd>
      <dt>${t('common.type')}:</dt>
      <dd class="fs-text-wrap">
        ${camera.provider}
      </dd>
    </div>
  `
      : `
      <img class="fs__lpr-camera-icon" src="/assets/fusus-icons/PNG/${imgIcon}.png"/>
    `;
    content.classList.add('fs__center-marker');
  }

  get icon(): string {
    return this._getCameraIcon(this.camera);
  }

  public formatDate(data: Date | string): Date {
    const date = new Date(data);
    date.setHours(date.getHours() + 12);
    return date;
  }

  private _getCameraIcon(item: LprCameraModel): any {
    switch (true) {
      case item.provider?.toString() === 'FLOCK_SAFETY':
        return { makeIcon: 'Icon_FS', hasIcon: true };
      case item.provider?.toString().includes('GENETEC'):
      case item.provider?.toString().includes('GENETEC_SHARP3'):
      case item.provider?.toString().includes('GENETEC_SHARP5'):
        return { makeIcon: 'Icon_Genetec', hasIcon: true };
      case item.provider?.toString().includes('VIGILANT'):
        return { makeIcon: 'Icon_Vigilant', hasIcon: true };
      case item.provider?.toString().includes('REKOR'):
        return { makeIcon: 'Icon_Rekor', hasIcon: true };
      default:
        return { makeIcon: 'FususALPR', hasIcon: false };
    }
  }
}
